// @ts-nocheck
import React, { useMemo, useCallback, useState, useEffect, useRef } from 'react';
import { Form } from 'react-final-form';
import { useHistory, useParams } from 'react-router-dom';
import { Button, ButtonWithLoading } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import { Card, CardBody, CardTitle } from '@spark/ui-components/components/Card';
import { FormButtonToolbar, FormContainer } from '@spark/ui-components/components/form/FormElements';
import DynamicForm from '@spark/ui-components/components/form/DynamicForm';
import { formStructure, formSections, validateForm } from './formConfig';
import { createDepots, getDepotsById, updateDepots } from '@spark/services/depots';
import { removeAnexoAcompanhamento } from '@spark/services/acompanhamentos';
import { getMotoristas, getVeiculos, getVeiculoById } from '@spark/services';
import { toApiDate } from '@spark/utils/formatters/formatters';
import { notification } from '@spark/ui-components/utils/notification';
import AnexarReciboModal from '../../../Listagem/components/AnexarReciboModal';
import ConfirmChangeModal from '@/containers/UI/Modals/index2';
import * as S from './index-styled';
import {
  formatDateToApi,
  toDateOrNull,
  formatTipoPagamentoToSelect,
  formatCpfCnpj,
  sanitizeDigits,
  extractSelectValue,
  parseCurrencyToNumber,
  formatCurrencyBr,
  formatStatusCtnrToSelect,
  formatSituacaoDepotToSelect,
  formatTipoTomadorToSelect,
} from './formatters/formatters';

const statusOptions = [
  { value: 'coleta_no_porto', label: 'COLETA PORTO' },
  { value: 'baixado_aguardando_cheio_barra_velha', label: 'BX CHEIO BV' },
  { value: 'baixado_aguardando_cheio_itapoa', label: 'BX CHEIO ITA' },
  { value: 'baixado_aguardando_vazio_barra_velha', label: 'BX VAZIO BV' },
  { value: 'baixado_aguardando_vazio_itapoa', label: 'BX VAZIO ITA' },
  { value: 'finalizado', label: 'FINALIZADO' },
];

const formatStatusToSelect = (value) => {
  if (!value) return '';
  const found = statusOptions.find((opt) => opt.value === value);
  return found || { value, label: String(value).replace(/_/g, ' ').toUpperCase() };
};

const mapFormToApi = (values) => {
  const toNumberOrZero = (v) => {
    const raw = v && typeof v === 'object' && 'value' in v ? v.value : v;
    if (raw === '' || raw === null || raw === undefined) return 0;
    const n = Number(raw);
    return Number.isNaN(n) ? 0 : n;
  };

  const toNumberOrNull = (v) => {
    const raw = v && typeof v === 'object' && 'value' in v ? v.value : v;
    if (raw === '' || raw === null || raw === undefined) return null;
    const n = Number(raw);
    return Number.isNaN(n) ? null : n;
  };

  const usarTipoTomador = !!values.utilizarTipoTomadorInformado;

  return {
    ReferenciaCLiente: values.referenciaCliente || '',
    TipoDepot: extractSelectValue(values.tipoDepot) || '',
    NumeroContainer: values.numeroContainer || '',
    TipoContainer: extractSelectValue(values.tipoContainer) || '',
    LocalColeta: values.localColeta || '',
    DataColeta: formatDateToApi(values.dataColeta),
    StatusPedido: extractSelectValue(values.statusPedido) || '',
    Status: extractSelectValue(values.status) || '',
    DataEntrega: formatDateToApi(values.dataEntrega),
    Local: values.local || '',
    LocalDevolucao: values.localDevolucao || '',
    DataDevolucao: formatDateToApi(values.dataDevolucao),
    FreeTime: formatDateToApi(values.freeTime),
    MotDepot: values.motDepot || '',
    IdMotoristaColeta:
      extractSelectValue(values.motoristaColetaNome, { toNumber: true }) ?? toNumberOrZero(values.idMotoristaColeta),
    SituacaoDepot: toNumberOrZero(values.situacaoDepot),
    IdVeiculoColeta: toNumberOrZero(values.idVeiculoColeta),
    IdVeiculoColetaCarreta: toNumberOrZero(values.idCarretaColeta),
    IdMotoristaEntrega:
      extractSelectValue(values.motoristaEntregaNome, { toNumber: true }) ??
      toNumberOrZero(values.idMotoristaEntrega),
    IdMotoristaDevolucao: extractSelectValue(values.motoristaDevolucaoNome, { toNumber: true }) ?? 0,
    IdVeiculoEntrega: toNumberOrZero(values.idVeiculoEntrega),
    IdVeiculoDevolucao: toNumberOrZero(values.IdVeiculoDevolucao),
    AnotacoesProgramacao: values.anotacoesProgramacao || '',
    AnotacoesOperacionais: values.anotacoesOperacionais || '',
    StatusPedidoEmissaoTMS: values.statusPedidoEmissaoTMS || '',
    TransportadoraEmitenteCnpj: sanitizeDigits(values.transportadoraEmitenteCnpj),
    RemetenteCpfCnpj: sanitizeDigits(values.remetenteCpfCnpj),
    DestinatarioCpfCnpj: sanitizeDigits(values.destinatarioCpfCnpj),
    TomadorCpfCnpj: usarTipoTomador ? sanitizeDigits(values.tomadorCpfCnpj) : null,
    TipoTomador: usarTipoTomador ? toNumberOrNull(values.tipoTomador) : null,
    UtilizarTipoTomadorInformado: usarTipoTomador,
    TipoPagamento: toNumberOrNull(values.tipoPagamento),
    TipoOperacaoCodigo: values.tipoOperacaoCodigo || '',
    TipoCargaEmbarcadorCodigo: values.tipoCargaEmbarcadorCodigo || '',
    Observacao: values.observacao || '',
    ValorFrete: parseCurrencyToNumber(values.valorFrete),
  };
};

const mapApiToForm = (dados = {}) => ({
  referenciaCliente: dados.ReferenciaCLiente || dados.ReferenciaCliente || '',
  tipoDepot: dados.TipoDepot || '',
  numeroContainer: dados.NumeroContainer || '',
  tipoContainer: dados.TipoContainer || '',
  statusPedido: dados.StatusPedido || '',
  status: formatStatusToSelect(dados.Status || ''),
  alerta: dados.Alerta || '',
  localColeta: dados.LocalColeta || '',
  local: dados.Local || '',
  localDevolucao: dados.LocalDevolucao || '',
  dataColeta: toDateOrNull(dados.DataColeta),
  dataEntrega: toDateOrNull(dados.DataEntrega),
  dataDevolucao: toDateOrNull(dados.DataDevolucao),
  freeTime: toDateOrNull(dados.FreeTime),
  idMotoristaColeta: dados.IdMotoristaColeta ?? '',
  motoristaColetaCpf: formatCpfCnpj(dados.MotoristaColeta?.Cpf || ''),
  motoristaColetaNome: dados.IdMotoristaColeta
    ? {
      value: dados.IdMotoristaColeta,
      label: dados.MotoristaColeta?.Nome || '',
      cpf: formatCpfCnpj(dados.MotoristaColeta?.Cpf || ''),
      meta: {
        cpf: formatCpfCnpj(dados.MotoristaColeta?.Cpf || ''),
      },
    }
    : '',
  idMotoristaEntrega: dados.IdMotoristaEntrega ?? '',
  motoristaEntregaCpf: formatCpfCnpj(dados.MotoristaEntrega?.Cpf || ''),
  motoristaEntregaNome: dados.IdMotoristaEntrega
    ? {
      value: dados.IdMotoristaEntrega,
      label: dados.MotoristaEntrega?.Nome || '',
      cpf: formatCpfCnpj(dados.MotoristaEntrega?.Cpf || ''),
      meta: {
        cpf: formatCpfCnpj(dados.MotoristaEntrega?.Cpf || ''),
      },
    }
    : '',
  idMotoristaDevolucao: dados.IdMotoristaDevolucao ?? '',
  motoristaDevolucaoCpf: formatCpfCnpj(dados.MotoristaDevolucao?.Cpf || ''),
  motoristaDevolucaoNome: dados.IdMotoristaDevolucao
    ? {
      value: dados.IdMotoristaDevolucao,
      label: dados.MotoristaDevolucao?.Nome || '',
      cpf: formatCpfCnpj(dados.MotoristaDevolucao?.Cpf || ''),
      meta: {
        cpf: formatCpfCnpj(dados.MotoristaDevolucao?.Cpf || ''),
      },
    }
    : '',
  idVeiculoColeta:
    dados.IdVeiculoColeta || dados.VeiculoColeta
      ? {
        value: dados.IdVeiculoColeta || dados.VeiculoColeta?.Id || '',
        label:
          dados.VeiculoColeta?.Frota ||
          dados.VeiculoColeta?.Placa ||
          (dados.IdVeiculoColeta ? `Veículo ${dados.IdVeiculoColeta}` : ''),
        frota: dados.VeiculoColeta?.Frota || '',
        placa: dados.VeiculoColeta?.Placa || '',
        meta: {
          frota: dados.VeiculoColeta?.Frota || '',
          placa: dados.VeiculoColeta?.Placa || '',
        },
      }
      : '',
  veiculoColetaPlaca: dados.VeiculoColeta?.Placa || '',
  veiculoColetaFrota: dados.VeiculoColeta?.Frota || '',
  idCarretaColeta:
    dados.IdVeiculoColetaCarreta || dados.VeiculoColetaCarreta
      ? {
        value: dados.IdVeiculoColetaCarreta || dados.VeiculoColetaCarreta?.Id || '',
        label:
          dados.VeiculoColetaCarreta?.Frota ||
          dados.VeiculoColetaCarreta?.Placa ||
          (dados.IdVeiculoColetaCarreta ? `Veículo ${dados.IdVeiculoColetaCarreta}` : ''),
        frota: dados.VeiculoColetaCarreta?.Frota || '',
        placa: dados.VeiculoColetaCarreta?.Placa || '',
        meta: {
          frota: dados.VeiculoColetaCarreta?.Frota || '',
          placa: dados.VeiculoColetaCarreta?.Placa || '',
        },
      }
      : '',
  carretaColetaPlaca: dados.VeiculoColetaCarreta?.Placa || '',
  idVeiculoEntrega:
    dados.IdVeiculoEntrega || dados.VeiculoEntrega
      ? {
        value: dados.IdVeiculoEntrega || dados.VeiculoEntrega?.Id || '',
        label:
          dados.VeiculoEntrega?.Frota ||
          dados.VeiculoEntrega?.Placa ||
          (dados.IdVeiculoEntrega ? `Veículo ${dados.IdVeiculoEntrega}` : ''),
        frota: dados.VeiculoEntrega?.Frota || '',
        placa: dados.VeiculoEntrega?.Placa || '',
        meta: {
          frota: dados.VeiculoEntrega?.Frota || '',
          placa: dados.VeiculoEntrega?.Placa || '',
        },
      }
      : '',
  veiculoEntregaPlaca: dados.VeiculoEntrega?.Placa || '',
  veiculoEntregaFrota: dados.VeiculoEntrega?.Frota || '',
  IdVeiculoDevolucao:
    dados.IdVeiculoDevolucao || dados.VeiculoDevolucao
      ? {
        value: dados.IdVeiculoDevolucao || dados.VeiculoDevolucao?.Id || '',
        label:
          dados.VeiculoDevolucao?.Frota ||
          dados.VeiculoDevolucao?.Placa ||
          (dados.IdVeiculoDevolucao ? `Veículo ${dados.IdVeiculoDevolucao}` : ''),
        frota: dados.VeiculoDevolucao?.Frota || '',
        placa: dados.VeiculoDevolucao?.Placa || '',
        meta: {
          frota: dados.VeiculoDevolucao?.Frota || '',
          placa: dados.VeiculoDevolucao?.Placa || '',
        },
      }
      : '',
  veiculoDevolucaoPlaca: dados.VeiculoDevolucao?.Placa || '',
  situacaoDepot: formatSituacaoDepotToSelect(dados.SituacaoDepot),
  motDepot: dados.MotDepot || '',
  anotacoesProgramacao: dados.AnotacoesProgramacao || '',
  anotacoesOperacionais: dados.AnotacoesOperacionais || '',
  statusPedidoEmissaoTMS: dados.StatusPedidoEmissaoTMS || '',
  transportadoraEmitenteCnpj: formatCpfCnpj(dados.TransportadoraEmitenteCnpj),
  remetenteCpfCnpj: formatCpfCnpj(dados.RemetenteCpfCnpj),
  destinatarioCpfCnpj: formatCpfCnpj(dados.DestinatarioCpfCnpj),
  tomadorCpfCnpj: formatCpfCnpj(
    dados.TomadorCpfCnpj ||
    dados?.Pedidos?.[0]?.TomadorCpfCnpj ||
    dados?.Pedido?.TomadorCpfCnpj ||
    dados?.pedido?.TomadorCpfCnpj,
  ),
  tipoTomador: formatTipoTomadorToSelect(
    dados.TipoTomador ??
    dados?.Pedidos?.[0]?.TipoTomador ??
    dados?.Pedido?.TipoTomador ??
    dados?.pedido?.TipoTomador,
  ),
  utilizarTipoTomadorInformado: !!dados.UtilizarTipoTomadorInformado,
  tipoPagamento: formatTipoPagamentoToSelect(dados.TipoPagamento),
  tipoOperacaoCodigo: dados.TipoOperacaoCodigo || '',
  tipoCargaEmbarcadorCodigo: dados.TipoCargaEmbarcadorCodigo || '',
  observacao: dados.Observacao || '',
  valorFrete: dados.ValorFrete ?? '',
});

const defaultValues = {
  referenciaCliente: '',
  numeroContainer: '',
  tipoContainer: '',
  numeroEmbarcador: '',
  statusPedido: '',
  status: '',
  alerta: '',
  localColeta: '',
  local: '',
  localDevolucao: '',
  dataColeta: null,
  dataEntrega: null,
  dataDevolucao: null,
  freeTime: null,
  statusPedidoEmissaoTMS: '',
  transportadoraEmitenteCnpj: '',
  remetenteCpfCnpj: '',
  destinatarioCpfCnpj: '',
  tomadorCpfCnpj: '',
  tipoTomador: '',
  utilizarTipoTomadorInformado: false,
  tipoPagamento: '',
  tipoOperacaoCodigo: '',
  tipoCargaEmbarcadorCodigo: '',
  observacao: '',
  valorFrete: '',
  idMotoristaColeta: '',
  motoristaColetaNome: '',
  motoristaColetaCpf: '',
  idMotoristaEntrega: '',
  motoristaEntregaNome: '',
  motoristaEntregaCpf: '',
  idMotoristaDevolucao: '',
  motoristaDevolucaoNome: '',
  motoristaDevolucaoCpf: '',
  idVeiculoColeta: '',
  veiculoColetaPlaca: '',
  veiculoColetaFrota: '',
  idCarretaColeta: '',
  carretaColetaPlaca: '',
  idVeiculoEntrega: '',
  veiculoEntregaPlaca: '',
  veiculoEntregaFrota: '',
  IdVeiculoDevolucao: '',
  veiculoDevolucaoPlaca: '',
  situacaoDepot: null,
  motDepot: '',
  anotacoesProgramacao: '',
  anotacoesOperacionais: '',
};

const ValidationToast = ({ submitCount, hasValidationErrors }) => {
  const lastSubmitCountRef = useRef(0);

  useEffect(() => {
    if (hasValidationErrors && submitCount > lastSubmitCountRef.current) {
      notification.error('Preencha os campos obrigat�rios.');
      lastSubmitCountRef.current = submitCount;
    }
  }, [submitCount, hasValidationErrors]);

  return null;
};

const Forms = () => {
  const history = useHistory();
  const { id } = useParams();
  const isEdit = !!id;
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [initialValues, setInitialValues] = useState(defaultValues);
  const [anexos, setAnexos] = useState([]);
  const [removingId, setRemovingId] = useState(null);
  const [pendingRemoveAnexo, setPendingRemoveAnexo] = useState(null);
  const [anexoModalOpen, setAnexoModalOpen] = useState(false);
  const [anexoTag, setAnexoTag] = useState('Coleta');

  const loadAnexos = useCallback(async () => {
    if (!isEdit) return;
    try {
      const response = await getDepotsById(id);
      const depot = response?.depot || response;
      const lista = depot?.Anexos ?? depot?.anexos ?? [];
      setAnexos(Array.isArray(lista) ? lista : []);
    } catch (err) {
      console.error('Erro ao carregar anexos:', err);
    }
  }, [id, isEdit]);

  useEffect(() => {
    let isActive = true;

    const loadDepot = async () => {
      if (!isEdit) {
        if (isActive) {
          setInitialValues(defaultValues);
        }
        return;
      }

      try {
        setLoadingData(true);
        const response = await getDepotsById(id);
        if (!isActive) return;
        const depot = response?.depot || response;
        setInitialValues(mapApiToForm(depot || {}));
        const lista = depot?.Anexos ?? depot?.anexos ?? [];
        setAnexos(Array.isArray(lista) ? lista : []);
      } catch (err) {
        if (!isActive) return;
        console.error(err);
        alert('Erro ao carregar dados do depot.');
      } finally {
        if (isActive) {
          setLoadingData(false);
        }
      }
    };

    loadDepot();

    return () => {
      isActive = false;
    };
  }, [id, isEdit]);

  const handleRemoveAnexo = useCallback((anexo) => {
    if (!anexo?.Id) return;
    setPendingRemoveAnexo(anexo);
  }, []);

  const handleConfirmRemoveAnexo = useCallback(async () => {
    const anexoId = pendingRemoveAnexo?.Id;
    if (!anexoId) return;
    try {
      setRemovingId(anexoId);
      await removeAnexoAcompanhamento(anexoId);
      setAnexos((prev) => prev.filter((item) => item.Id !== anexoId));
    } catch (err) {
      console.error('Erro ao remover anexo:', err);
      alert('Erro ao remover anexo.');
    } finally {
      setRemovingId(null);
      setPendingRemoveAnexo(null);
    }
  }, [pendingRemoveAnexo]);

  const handleCloseRemoveModal = useCallback(() => {
    if (removingId) return;
    setPendingRemoveAnexo(null);
  }, [removingId]);

  const handleOpenAnexoModal = useCallback((tag) => {
    setAnexoTag(tag ?? 'Coleta');
    setAnexoModalOpen(true);
  }, []);

  const handleCloseAnexoModal = useCallback(() => {
    setAnexoModalOpen(false);
  }, []);

  const handleUploadedAnexo = useCallback(() => {
    loadAnexos();
  }, [loadAnexos]);

  const isColetaAnexo = (anexo) => {
    const nome = (anexo?.NomeArquivo || anexo?.NomeOriginal || '').toLowerCase();
    return nome.startsWith('coleta');
  };

  const isDevolucaoAnexo = (anexo) => {
    const nome = (anexo?.NomeArquivo || anexo?.NomeOriginal || '').toLowerCase();
    return nome.startsWith('devolucao');
  };

  const isDepotAnexo = (anexo) => !isColetaAnexo(anexo) && !isDevolucaoAnexo(anexo);

  const anexosColeta = anexos?.filter(isColetaAnexo) || [];
  const anexosDevolucao = anexos?.filter(isDevolucaoAnexo) || [];
  const anexosDepot = anexos?.filter(isDepotAnexo) || [];

  const renderAnexos = (lista = [], addButton) => {
    if (loadingData) return <p style={{ marginTop: 16 }}>Carregando anexos...</p>;
    if (!lista?.length) {
      return (
        <S.AnexosGrid>
          {addButton}
          <p style={{ marginTop: 16, marginBottom: 0 }}>Nenhum anexo enviado.</p>
        </S.AnexosGrid>
      );
    }

    return (
      <S.AnexosGrid>
        {addButton}
        {lista.map((anexo) => {
          const src = anexo.UrlArquivo || '';
          const nome = anexo.NomeArquivo || anexo.NomeOriginal || 'Anexo';
          const isRemoving = removingId === anexo.Id;
          return (
            <S.AnexoItem key={anexo.Id}>
              <S.Caption>
                <S.FileTag
                  type="button"
                  onClick={() => {
                    if (src) {
                      window.open(src, '_blank', 'noopener');
                    }
                  }}
                  title={nome}
                >
                  {nome}
                </S.FileTag>
                <S.RemoveButton
                  type="button"
                  onClick={() => handleRemoveAnexo(anexo)}
                  disabled={isRemoving}
                  aria-label="Remover anexo"
                >
                  {isRemoving ? (
                    '...'
                  ) : (
                    <Icon name="trash" size={18} />
                  )}
                </S.RemoveButton>
              </S.Caption>
            </S.AnexoItem>
          );
        })}
      </S.AnexosGrid>
    );
  };

  const onSubmit = useCallback(
    async (values) => {
      try {
        setLoading(true);
        const payload = mapFormToApi(values);
        if (isEdit) {
          await updateDepots(id, payload);
        } else {
          await createDepots(payload);
        }
        history.push('/pages/containers/programacao');
      } catch (err) {
        alert(`Erro ao ${isEdit ? 'atualizar' : 'criar'} Depot: ${err.message}`);
      } finally {
        setLoading(false);
      }
    },
    [history, id, isEdit],
  );

  if (loadingData) {
    return <div style={{ padding: 32 }}>Carregando dados do depot...</div>;
  }

  return (
    <>
      <Form onSubmit={onSubmit} initialValues={initialValues} validate={validateForm}>
        {({ handleSubmit, values, form, submitCount, hasValidationErrors }) => (
          <Card>
            <CardBody>
              <ValidationToast
                submitCount={submitCount}
                hasValidationErrors={hasValidationErrors}
              />
              <S.HeaderWrap>
                <CardTitle>{isEdit ? 'Editar Depot' : 'Cadastro de Depot'}</CardTitle>
              </S.HeaderWrap>
              <DepotFormContent
                handleSubmit={handleSubmit}
                values={values}
                form={form}
                isEdit={isEdit}
                loading={loading}
                renderAnexos={renderAnexos}
                anexosColeta={anexosColeta}
                anexosEntrega={anexosDevolucao}
                anexosDepot={anexosDepot}
                onOpenAnexoModal={handleOpenAnexoModal}
                history={history}
              />
            </CardBody>
          </Card>
        )}
      </Form>
      {isEdit && (
        <AnexarReciboModal
          key={`${id || 'new'}-${anexoTag}`}
          show={anexoModalOpen}
          onClose={handleCloseAnexoModal}
          depotId={id}
          onUploaded={handleUploadedAnexo}
          enableTagSelect={false}
          defaultTag={anexoTag}
          lockTag={Boolean(anexoTag)}
        />
      )}
      <ConfirmChangeModal
        show={Boolean(pendingRemoveAnexo)}
        onClose={handleCloseRemoveModal}
        onConfirm={handleConfirmRemoveAnexo}
        loading={Boolean(removingId)}
        title="Remover anexo"
        message={`Tem certeza que deseja remover o anexo "${pendingRemoveAnexo?.NomeArquivo || pendingRemoveAnexo?.NomeOriginal || 'este item'}"?`}
        confirmButtonText="Remover"
        confirmButtonVariant="danger"
        loadingText="Removendo..."
      />

    </>
  );
};

export default Forms;

const DepotFormContent = ({
  handleSubmit,
  values,
  form,
  isEdit,
  loading,
  renderAnexos,
  anexosColeta,
  anexosEntrega,
  anexosDepot,
  onOpenAnexoModal,
  history,
}) => {
  const usarTipoTomador = !!values.utilizarTipoTomadorInformado;

  useEffect(() => {
    if (usarTipoTomador) return;
    form.batch(() => {
      form.change('tomadorCpfCnpj', null);
      form.change('tipoTomador', null);
    });
  }, [usarTipoTomador, form]);

  const structureWithLocks = useMemo(() => {
    return formStructure.map((row) =>
      row.map((field) => {
        if (field?.name === 'tomadorCpfCnpj' || field?.name === 'tipoTomador') {
          return { ...field, disabled: !usarTipoTomador, readOnly: !usarTipoTomador };
        }
        return field;
      }),
    );
  }, [usarTipoTomador]);

  const searchMotoristas = useCallback(async (searchTerm) => {
    try {
      const response = await getMotoristas({
        Nome: searchTerm,
        quantidadePorPagina: 10,
        pagina: 1,
      });
      const lista = response?.registros || response?.data || response || [];
      return Array.isArray(lista)
        ? lista.map((mot) => ({
          value: mot.Id,
          label: mot.Nome || `Motorista ${mot.Id}`,
          cpf: formatCpfCnpj(mot.Cpf || mot.CPF || mot.cpf || ''),
          meta: {
            cpf: formatCpfCnpj(mot.Cpf || mot.CPF || mot.cpf || ''),
          },
        }))
        : [];
    } catch (err) {
      console.error('Erro ao buscar motoristas:', err);
      return [];
    }
  }, []);

  const searchVeiculos = useCallback(async (searchTerm) => {
    try {
      const response = await getVeiculos({
        frota: searchTerm,
        quantidadePorPagina: 10,
        pagina: 1,
      });
      const lista = response?.registros || response?.data?.registros || response?.data || response || [];
      return Array.isArray(lista)
        ? lista.map((veic) => ({
          value: veic.Id,
          label: veic.Frota || veic.Placa || `Veículo ${veic.Id}`,
          frota: veic.Frota || '',
          placa: veic.Placa || '',
          meta: {
            frota: veic.Frota || '',
            placa: veic.Placa || '',
          },
        }))
        : [];
    } catch (err) {
      console.error('Erro ao buscar veículos:', err);
      return [];
    }
  }, []);

  useEffect(() => {
    const opt = values.motoristaColetaNome;
    if (!opt) {
      if (values.motoristaColetaCpf) form.change('motoristaColetaCpf', '');
      return;
    }
    const cpf = opt?.cpf || opt?.meta?.cpf || opt?.data?.cpf || '';
    if (cpf && cpf !== values.motoristaColetaCpf) {
      form.change('motoristaColetaCpf', cpf);
    }
  }, [values.motoristaColetaNome, values.motoristaColetaCpf, form]);

  useEffect(() => {
    const opt = values.motoristaEntregaNome;
    if (!opt) {
      if (values.motoristaEntregaCpf) form.change('motoristaEntregaCpf', '');
      return;
    }
    const cpf = opt?.cpf || opt?.meta?.cpf || opt?.data?.cpf || '';
    if (cpf && cpf !== values.motoristaEntregaCpf) {
      form.change('motoristaEntregaCpf', cpf);
    }
  }, [values.motoristaEntregaNome, values.motoristaEntregaCpf, form]);

  useEffect(() => {
    const opt = values.motoristaDevolucaoNome;
    if (!opt) {
      if (values.motoristaDevolucaoCpf) form.change('motoristaDevolucaoCpf', '');
      return;
    }
    const cpf = opt?.cpf || opt?.meta?.cpf || opt?.data?.cpf || '';
    if (cpf && cpf !== values.motoristaDevolucaoCpf) {
      form.change('motoristaDevolucaoCpf', cpf);
    }
  }, [values.motoristaDevolucaoNome, values.motoristaDevolucaoCpf, form]);

  useEffect(() => {
    let isActive = true;
    const opt = values.idVeiculoColeta;
    const frota = opt?.frota || opt?.meta?.frota || opt?.data?.frota || '';
    const placa = opt?.placa || opt?.meta?.placa || opt?.data?.placa || opt?.label || '';
    const id = opt?.value ?? opt;

    if (frota || placa) {
      form.batch(() => {
        form.change('veiculoColetaFrota', frota);
        form.change('veiculoColetaPlaca', placa);
      });
      return;
    }

    if (!id) {
      form.batch(() => {
        form.change('veiculoColetaFrota', '');
        form.change('veiculoColetaPlaca', '');
      });
      return;
    }

    const fetchVeiculo = async () => {
      try {
        const resp = await getVeiculoById(id);
        if (!isActive) return;
        const v = resp?.veiculo || resp || {};
        form.batch(() => {
          form.change('veiculoColetaFrota', v.Frota || '');
          form.change('veiculoColetaPlaca', v.Placa || '');
        });
      } catch (err) {
        if (!isActive) return;
        console.error('Erro ao obter veiculo coleta:', err);
        form.batch(() => {
          form.change('veiculoColetaFrota', '');
          form.change('veiculoColetaPlaca', '');
        });
      }
    };

    fetchVeiculo();

    return () => {
      isActive = false;
    };
  }, [values.idVeiculoColeta, form]);

  useEffect(() => {
    let isActive = true;
    const opt = values.idCarretaColeta;
    const placa = opt?.placa || opt?.meta?.placa || opt?.data?.placa || opt?.label || '';
    const id = opt?.value ?? opt;

    if (placa) {
      form.change('carretaColetaPlaca', placa);
      return;
    }

    if (!id) {
      form.change('carretaColetaPlaca', '');
      return;
    }

    const fetchVeiculo = async () => {
      try {
        const resp = await getVeiculoById(id);
        if (!isActive) return;
        const v = resp?.veiculo || resp || {};
        form.change('carretaColetaPlaca', v.Placa || '');
      } catch (err) {
        if (!isActive) return;
        console.error('Erro ao obter carreta de coleta:', err);
        form.change('carretaColetaPlaca', '');
      }
    };

    fetchVeiculo();

    return () => {
      isActive = false;
    };
  }, [values.idCarretaColeta, form]);

  useEffect(() => {
    let isActive = true;
    const opt = values.idVeiculoEntrega;
    const frota = opt?.frota || opt?.meta?.frota || opt?.data?.frota || '';
    const placa = opt?.placa || opt?.meta?.placa || opt?.data?.placa || opt?.label || '';
    const id = opt?.value ?? opt;

    if (frota || placa) {
      form.batch(() => {
        form.change('veiculoEntregaFrota', frota);
        form.change('veiculoEntregaPlaca', placa);
      });
      return;
    }

    if (!id) {
      form.batch(() => {
        form.change('veiculoEntregaFrota', '');
        form.change('veiculoEntregaPlaca', '');
      });
      return;
    }

    const fetchVeiculo = async () => {
      try {
        const resp = await getVeiculoById(id);
        if (!isActive) return;
        const v = resp?.veiculo || resp || {};
        form.batch(() => {
          form.change('veiculoEntregaFrota', v.Frota || '');
          form.change('veiculoEntregaPlaca', v.Placa || '');
        });
      } catch (err) {
        if (!isActive) return;
        console.error('Erro ao obter veiculo entrega:', err);
        form.batch(() => {
          form.change('veiculoEntregaFrota', '');
          form.change('veiculoEntregaPlaca', '');
        });
      }
    };

    fetchVeiculo();

    return () => {
      isActive = false;
    };
  }, [values.idVeiculoEntrega, form]);

  useEffect(() => {
    let isActive = true;
    const opt = values.IdVeiculoDevolucao;
    const placa = opt?.placa || opt?.meta?.placa || opt?.data?.placa || opt?.label || '';
    const id = opt?.value ?? opt;

    if (placa) {
      form.change('veiculoDevolucaoPlaca', placa);
      return;
    }

    if (!id) {
      form.change('veiculoDevolucaoPlaca', '');
      return;
    }

    const fetchVeiculo = async () => {
      try {
        const resp = await getVeiculoById(id);
        if (!isActive) return;
        const v = resp?.veiculo || resp || {};
        form.change('veiculoDevolucaoPlaca', v.Placa || '');
      } catch (err) {
        if (!isActive) return;
        console.error('Erro ao obter veiculo devolução:', err);
        form.change('veiculoDevolucaoPlaca', '');
      }
    };

    fetchVeiculo();

    return () => {
      isActive = false;
    };
  }, [values.IdVeiculoDevolucao, form]);

  const searchClientes = useCallback(async (searchTerm) => {
    try {
      const response = await getClientes({ Nome: searchTerm, quantidadePorPagina: 30 });
      const registros = response?.registros || response?.Registros || [];

      return registros.map((item) => ({
        value: String(item.Id || item.id),
        label: item.Nome || item.nome || `Cliente ${item.Id || item.id}`,
      }));
    } catch (error) {
      console.error('Erro ao buscar clientes:', error);
      return [];
    }
  }, []);

  const searchFunctions = {
    IdCliente: searchClientes,
    motoristaColetaNome: searchMotoristas,
    motoristaEntregaNome: searchMotoristas,
    motoristaDevolucaoNome: searchMotoristas,
    idVeiculoColeta: searchVeiculos,
    idCarretaColeta: searchVeiculos,
    idVeiculoEntrega: searchVeiculos,
    IdVeiculoDevolucao: searchVeiculos,
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <DynamicForm
        structure={structureWithLocks}
        sections={formSections(values)}
        searchFunctions={searchFunctions}
      />
      {isEdit ? (
        <>
          <Card className="mt-1">
            <CardBody>
              <CardTitle>Anexos da Coleta</CardTitle>
              <div>
                {renderAnexos(
                  anexosColeta,
                  <S.AddTagButton
                    type="button"
                    onClick={() => onOpenAnexoModal('Coleta')}
                    aria-label="Adicionar anexo da coleta"
                  >
                    <Icon name="plus" size={18} />
                  </S.AddTagButton>,
                )}
              </div>
              <CardTitle style={{ marginTop: 20 }}>Anexos da Devolução</CardTitle>
              <div style={{ marginTop: 10 }}>
                {renderAnexos(
                  anexosEntrega,
                  <S.AddTagButton
                    type="button"
                    onClick={() => onOpenAnexoModal('Devolucao')}
                    aria-label="Adicionar anexo da entrega"
                  >
                    <Icon name="plus" size={18} />
                  </S.AddTagButton>,
                )}
              </div>
              <CardTitle style={{ marginTop: 20 }}>Anexos do depot</CardTitle>
              <div style={{ marginTop: 10 }}>
                {renderAnexos(
                  anexosDepot,
                  <S.AddTagButton
                    type="button"
                    onClick={() => onOpenAnexoModal('')}
                    aria-label="Adicionar anexo do depot"
                  >
                    <Icon name="plus" size={18} />
                  </S.AddTagButton>,
                )}
              </div>
            </CardBody>
          </Card>
          <FormButtonToolbar>
            <ButtonWithLoading variant="primary" type="submit" loading={loading ? 'true' : undefined}>
              Atualizar
            </ButtonWithLoading>
            <Button variant="secondary" type="button" onClick={() => history.goBack()}>
              Cancelar
            </Button>
          </FormButtonToolbar>
        </>
      ) : (
        <FormButtonToolbar>
          <ButtonWithLoading variant="primary" type="submit" loading={loading ? 'true' : undefined}>
            Cadastrar
          </ButtonWithLoading>
          <Button variant="secondary" type="button" onClick={() => history.goBack()}>
            Voltar
          </Button>
        </FormButtonToolbar>
      )}
    </FormContainer>
  );
};


